document.addEventListener("DOMContentLoaded", function() {
    const financialsTab = document.querySelector('.financials-tab');
    if (!financialsTab) return;

    let apiManager = null;
    let currentTicker = null;
    let financialsData = null;
    let selectedMainTab = 2;
    let selectedPeriodTab = 1;
    let financialsPopup = null;
    const noStockMessage = financialsTab.querySelector(".no-stock-selected-message");
    const financialsContent = financialsTab.querySelectorAll(".financials-statement-dropdown, .financials-period-nav, .financials-table-container");

    function isPortraitMobileLayout() {
        return document.documentElement.classList.contains('desktop-portrait-accepted');
    }
    function updateStockSelectionState(hasStock) {
        if (noStockMessage) {
            if (hasStock) {
                noStockMessage.style.display = 'none';
                financialsContent.forEach(el => {
                    if (el) el.style.display = '';
                });
            } else {
                noStockMessage.style.display = 'flex';
                financialsContent.forEach(el => {
                    if (el) el.style.display = 'none';
                });
            }
        }
    }

    function checkStockSelection() {
        const rightPanelDataHandler = document.querySelector('[right-panel-data-handler]');
        let hasStock = false;

        if (rightPanelDataHandler && rightPanelDataHandler.components && rightPanelDataHandler.components['right-panel-data-handler']) {
            const ticker = rightPanelDataHandler.components['right-panel-data-handler'].currentTicker;
            hasStock = !!ticker;
        }

        if (!hasStock && window.globalState && window.globalState.currentTicker) {
            hasStock = true;
        }
        if (!hasStock && currentTicker) {
            hasStock = true;
        }

        updateStockSelectionState(hasStock);
    }

    checkStockSelection();

    async function initAPIManager() {
        try {
            if (window.RightPanelProxyAPIManager) {
                apiManager = await RightPanelProxyAPIManager.create();
                if (__LOG_INFO__) AppLog.info('✅ Financials API Manager initialized');
            } else {
                if (__LOG_ERROR__) AppLog.error('❌ RightPanelProxyAPIManager not found');
            }
        } catch (error) {
            if (__LOG_ERROR__) AppLog.error('❌ Failed to initialize API Manager:', error);
        }
    }

    function getCurrentTicker() {
        if (window.globalState && window.globalState.currentTicker) {
            return window.globalState.currentTicker;
        }
        const rightPanelDataHandler = document.querySelector('[right-panel-data-handler]');
        if (rightPanelDataHandler && rightPanelDataHandler.components && rightPanelDataHandler.components['right-panel-data-handler']) {
            const ticker = rightPanelDataHandler.components['right-panel-data-handler'].currentTicker;
            if (ticker) return ticker;
        }
        const scene = document.querySelector('a-scene');
        if (scene && scene.hasAttribute('right-panel-data-handler')) {
            const tickerAttr = scene.getAttribute('right-panel-data-handler');
            if (tickerAttr && tickerAttr.ticker) {
                return tickerAttr.ticker;
            }
        }
        return currentTicker;
    }

    async function fetchFinancialsData(ticker) {
        if (!apiManager) {
            await initAPIManager();
        }

        if (!apiManager) {
            if (__LOG_ERROR__) AppLog.error('❌ API Manager not available');
            return null;
        }

        try {
            if (__LOG_INFO__) AppLog.info(`📊 Fetching financials data for ${ticker}...`);
            const data = await apiManager.fetchFinancials(ticker);
            if (__LOG_INFO__) AppLog.info('✅ Financials data fetched:', data);
            return data;
        } catch (error) {
            if (__LOG_ERROR__) AppLog.error('❌ Failed to fetch financials data:', error);
            return null;
        }
    }

    function prepareTableData(financialsData, mainTabIndex, periodTabIndex) {
        if (!financialsData || typeof financialsData !== 'object') {
            return [['Breakdown', 'TTM', 'Period 1', 'Period 2', 'Period 3', 'Period 4'], ['No data', '', '', '', '', '']];
        }

        const mainTabTypes = ['income', 'balance', 'cashflow'];
        const periodTypes = ['annual', 'quarterly'];

        const tabType = mainTabTypes[mainTabIndex] || 'income';
        const periodType = periodTypes[periodTabIndex] || 'annual';

        let data = financialsData[tabType]?.[periodType];
        if (data && !Array.isArray(data)) {
            data = Object.values(data);
        }
        data = Array.isArray(data) ? data : [];

        let maxPeriods = 4;
        if (periodType === 'quarterly' && (tabType === 'balance' || tabType === 'cashflow')) {
            maxPeriods = 5;
        }

        const periods = data.slice(0, maxPeriods);
        if (periods.length === 0) {
            return [['Breakdown', 'TTM', 'Period 1', 'Period 2', 'Period 3', 'Period 4'], ['No data available', '', '', '', '', '']];
        }

        let ttmData = financialsData[tabType]?.ttm;
        if (!ttmData && periodType === 'quarterly') {
            const quarterlyData = financialsData[tabType]?.quarterly;
            if (quarterlyData && Array.isArray(quarterlyData) && quarterlyData.length >= 4) {
                ttmData = calculateTTM(quarterlyData.slice(0, 4), tabType);
            }
        }

        // Format number helper - all numbers are in thousands
        // Values are already in thousands, so:
        // 1,000,000,000 thousands = 1 trillion = 1T (divide by 1,000,000,000)
        // 1,000,000 thousands = 1 billion = 1B (divide by 1,000,000)
        // 1,000 thousands = 1 million = 1M (divide by 1,000)
        // < 1,000 thousands = show as thousands with K or format with decimals
        const formatNumber = (value, isEPS = false) => {
            if (value === null || value === undefined) return '--';
            const numValue = typeof value === 'number' ? value : parseFloat(value);
            if (isNaN(numValue)) return '--';
            if (numValue === 0) return '0';

            // For EPS, keep 2 decimal places
            if (isEPS) {
                return numValue.toFixed(2);
            }

            // Get absolute value for formatting
            const absValue = Math.abs(numValue);
            const sign = numValue < 0 ? '-' : '';

     
            if (absValue >= 1000000000) {
                const trillions = absValue / 1000000000;
                return `${sign}${trillions.toFixed(2)}B`;
            }

            else if (absValue >= 1000000) {
                const billions = absValue / 1000000;
                return `${sign}${billions.toFixed(2)}M`;
            }

            return `${sign}${Math.round(absValue).toLocaleString('en-US')}`;
        };

        const formatPeriod = (periodString) => {
            if (!periodString) return 'N/A';
            const date = new Date(periodString);
            if (isNaN(date.getTime())) return periodString;
            const month = date.getMonth() + 1;
            const day = date.getDate();
            const year = date.getFullYear();
            return `${month}/${day}/${year}`;
        };

        const getFieldNames = () => {
            if (tabType === 'income') {
                return [
                    { key: 'revenue', label: 'Revenue' },
                    { key: 'costOfRevenue', label: 'Cost of Revenue' },
                    { key: 'grossProfit', label: 'Gross Profit' },
                    { key: 'operatingExpense', label: 'Operating Expense' },
                    { key: 'operatingIncome', label: 'Operating Income' },
                    { key: 'nonOperatingIncome', label: 'Non-Operating Income' },
                    { key: 'interestIncome', label: 'Interest Income' },
                    { key: 'depreciationAmortization', label: 'Depreciation & Amortization' },
                    { key: 'pretaxIncome', label: 'Pretax Income' },
                    { key: 'taxes', label: 'Taxes' },
                    { key: 'netIncome', label: 'Net Income' },
                    { key: 'eps', label: 'EPS', isEPS: true },
                    { key: 'ebit', label: 'EBIT' },
                    { key: 'ebitda', label: 'EBITDA' }
                ];
            } else if (tabType === 'balance') {
                return [
                    { key: 'totalAssets', label: 'Total Assets' },
                    { key: 'totalLiabilities', label: 'Total Liabilities' },
                    { key: 'totalEquity', label: 'Total Equity' },
                    { key: 'currentAssets', label: 'Current Assets' },
                    { key: 'currentLiabilities', label: 'Current Liabilities' },
                    { key: 'cashAndCashEquivalents', label: 'Cash and Equivalents' },
                    { key: 'shortTermInvestments', label: 'Short-Term Investments' },
                    { key: 'accountsReceivable', label: 'Accounts Receivable' },
                    { key: 'inventory', label: 'Inventory' },
                    { key: 'longTermInvestments', label: 'Long-Term Investments' },
                    { key: 'propertyPlantEquipment', label: 'Property, Plant & Equipment' },
                    { key: 'goodwill', label: 'Goodwill' },
                    { key: 'intangibleAssets', label: 'Intangible Assets' }
                ];
            } else {
                return [
                    { key: 'operatingCashFlow', label: 'Operating Cash Flow' },
                    { key: 'investingCashFlow', label: 'Investing Cash Flow' },
                    { key: 'financingCashFlow', label: 'Financing Cash Flow' },
                    { key: 'netCashFlow', label: 'Net Cash Flow' },
                    { key: 'freeCashFlow', label: 'Free Cash Flow' },
                    { key: 'capitalExpenditure', label: 'Capital Expenditure' },
                    { key: 'netDividendsPaid', label: 'Dividends Paid' },
                    { key: 'stockRepurchases', label: 'Stock Repurchases' },
                    { key: 'debtIssuance', label: 'Debt Issuance' },
                    { key: 'debtRepayment', label: 'Debt Repayment' }
                ];
            }
        };

        const fieldNames = getFieldNames();
        const tableData = [];

        const header = ['Breakdown', 'TTM'];
        periods.forEach((period, index) => {
            header.push(formatPeriod(period.period) || `Period ${index + 1}`);
        });
        tableData.push(header);

        fieldNames.forEach(field => {
            const row = [field.label];

            if (ttmData && ttmData[field.key] !== undefined) {
                row.push(formatNumber(ttmData[field.key], field.isEPS));
            } else {
                row.push('--');
            }

            periods.forEach(period => {
                if (period[field.key] !== undefined) {
                    row.push(formatNumber(period[field.key], field.isEPS));
                } else {
                    row.push('--');
                }
            });

            tableData.push(row);
        });

        return tableData;
    }

    function calculateTTM(quarters, tabType) {
        if (!quarters || quarters.length < 4) return null;

        const ttm = {};
        const firstQuarter = quarters[0];

        Object.keys(firstQuarter).forEach(key => {
            if (key === 'period') return;
            const values = quarters.map(q => q[key]).filter(v => typeof v === 'number' && !isNaN(v));
            if (values.length > 0) {
                ttm[key] = values.reduce((sum, val) => sum + val, 0);
            }
        });

        return ttm;
    }

    function renderPreviewTable(financialsData, mainTabIndex, periodTabIndex) {
        const tableElement = document.querySelector('.financials-preview-table');
        if (!tableElement) return;
        const fullTableData = prepareTableData(financialsData, mainTabIndex, periodTabIndex);
        const isMobileLayout = document.documentElement.classList.contains('desktop-portrait-accepted');
        const previewData = isMobileLayout ? fullTableData : fullTableData.map(row => row.slice(0, 3));

        let html = '';
        previewData.forEach((row, rowIndex) => {
            html += '<tr>';
            row.forEach((cell, cellIndex) => {
                if (rowIndex === 0) {
                    html += `<th>${cell}</th>`;
                } else {
                    html += `<td>${cell}</td>`;
                }
            });
            html += '</tr>';
        });

        tableElement.innerHTML = html;
    }

    function renderTable(tableElement, tableData) {
        if (!tableElement || !tableData || tableData.length === 0) {
            tableElement.innerHTML = '<tr><td colspan="6">No data available</td></tr>';
            return;
        }

        if (__LOG_INFO__) AppLog.info(`Rendering table with ${tableData.length} rows and ${tableData[0]?.length || 0} columns`);

        let html = '';
        tableData.forEach((row, rowIndex) => {
            html += '<tr>';
            row.forEach((cell, cellIndex) => {
                if (rowIndex === 0) {
                    html += `<th>${cell}</th>`;
                } else {
                    html += `<td>${cell}</td>`;
                }
            });
            html += '</tr>';
        });

        tableElement.innerHTML = html;
    }

    async function openFinancialsExpanded() {
        if (isPortraitMobileLayout()) {
            return;
        }

        try {
            const ticker = getCurrentTicker();
            if (__LOG_INFO__) AppLog.info(`📊 Opening financials expanded view for ${ticker}`);

            const rightWrapper = document.querySelector('.right-wrapper');
            const mainBlock = document.getElementById('main-block');
            
            const financialsTabEl = document.querySelector('#right-container .financials-tab') || document.querySelector('.financials-tab');
            
            if (!financialsTabEl || !rightWrapper || !mainBlock) {
                 if (__LOG_ERROR__) AppLog.error('❌ Required elements not found', { rightWrapper, mainBlock, financialsTabEl });
                 if (rightWrapper) rightWrapper.classList.add('financials-expanded');
                 if (mainBlock) mainBlock.style.display = 'none';
                 return;
            }

            mainBlock.style.display = 'none';
            rightWrapper.classList.add('financials-expanded');
            financialsTabEl.classList.add('expanded');
            
            const tableContainer = financialsTabEl.querySelector('.financials-table-container');
            if (tableContainer) {
                tableContainer.classList.add('expanded');
                
                const previewWrapper = tableContainer.querySelector('.financials-preview-table-wrapper');
                if (previewWrapper) previewWrapper.style.display = 'none';
            } else {
                if (__LOG_WARN__) AppLog.warn('⚠️ Table container not found');
            }

            financialsPopup = { expanded: true };

            if (!tableContainer) return;

            if (!financialsData) {
                financialsData = await fetchFinancialsData(ticker);
            }

            let tableWrapper = tableContainer.querySelector('.financials-table-wrapper');
            if (!tableWrapper) {
                tableWrapper = document.createElement('div');
                tableWrapper.className = 'financials-table-wrapper';
                tableContainer.appendChild(tableWrapper);
            }

            let tableElement = tableWrapper.querySelector('.financials-table');
            if (!tableElement) {
                tableElement = document.createElement('table');
                tableElement.className = 'financials-table';
                tableElement.id = 'financials-expanded-table';
                tableWrapper.appendChild(tableElement);
            }

            try {
                if (!financialsData) {
                    throw new Error("Financials data is null after fetch");
                }
                const tableData = prepareTableData(financialsData, selectedMainTab, selectedPeriodTab);
                
                if (!Array.isArray(tableData)) {
                     throw new Error("prepareTableData did not return an array");
                }
                
                renderTable(tableElement, tableData);
            } catch (err) {
                if (__LOG_ERROR__) AppLog.error('❌ Error rendering table:', err);
                tableElement.innerHTML = `<tr><td style="color: red; padding: 20px;">Error loading data: ${err.message}<br><small>${err.stack}</small></td></tr>`;
            }

            tableWrapper.style.display = 'block';
            tableElement.style.display = 'table';

        } catch (e) {
            if (__LOG_ERROR__) AppLog.error('❌ Critical error in openFinancialsExpanded:', e);
            const rightWrapper = document.querySelector('.right-wrapper');
            if (rightWrapper) rightWrapper.classList.add('financials-expanded');
            const mainBlock = document.getElementById('main-block');
            if (mainBlock) mainBlock.style.display = 'none';
        }
    }
    
    function closeFinancialsExpanded() {
        if (__LOG_INFO__) AppLog.info('📊 Closing financials expanded view');
        const rightWrapper = document.querySelector('.right-wrapper');
        const mainBlock = document.getElementById('main-block');
        const financialsTabEl = document.querySelector('.financials-tab');
        const tableContainer = financialsTabEl?.querySelector('.financials-table-container');
        const tableElement = tableContainer?.querySelector('.financials-table');
        
        if (rightWrapper) {
            rightWrapper.classList.remove('financials-expanded');
        }

        if (mainBlock) {
            mainBlock.style.display = '';
        }

        const tableWrapper = tableContainer?.querySelector('.financials-table-wrapper');
        if (tableWrapper) {
            tableWrapper.style.display = 'none';
        }
        if (tableElement) {
            tableElement.style.display = 'none';
        }
        
        const previewWrapper = tableContainer?.querySelector('.financials-preview-table-wrapper');
        if (previewWrapper) {
            previewWrapper.style.display = 'block';
            if (__LOG_INFO__) AppLog.info('✅ Showing preview wrapper');
        }

        if (tableContainer) {
            tableContainer.classList.remove('expanded');
        }
        if (financialsTabEl) {
            financialsTabEl.classList.remove('expanded');
            if (__LOG_INFO__) AppLog.info('✅ Removed expanded class from tab');
        }

        financialsPopup = null;
    }

    window.closeFinancialsExpanded = closeFinancialsExpanded;
    window.openFinancialsExpanded = openFinancialsExpanded;

    function updateStatementLabel() {
        const statementLabels = ['Income Statement', 'Balance Sheet', 'Cash Flow Statement'];
        const statementDropdownBtn = financialsTab.querySelector('.statement-dropdown-btn .dropdown-label');
        if (statementDropdownBtn) {
            statementDropdownBtn.textContent = statementLabels[selectedMainTab] || 'Income Statement';
        }
    }

    function updateSelectedTabs() {
        const statementDropdown = financialsTab.querySelector('.financials-statement-dropdown');
        const statementDropdownBtn = financialsTab.querySelector('.statement-dropdown-btn');
        const statementDropdownMenu = financialsTab.querySelector('.statement-dropdown-menu');
        const statementItems = financialsTab.querySelectorAll('.statement-dropdown-menu .dropdown-item');

        if (statementDropdownBtn && statementDropdownMenu) {
            statementDropdownBtn.addEventListener('click', (e) => {
                e.stopPropagation();
                statementDropdown.classList.toggle('active');
            });

            statementItems.forEach((item, index) => {
                item.addEventListener('click', (e) => {
                    e.stopPropagation();
                    statementItems.forEach(i => i.classList.remove('active'));
                    item.classList.add('active');
                    selectedMainTab = index;
                    updateStatementLabel();
                    statementDropdown.classList.remove('active');

                    if (financialsData) {
                        renderPreviewTable(financialsData, selectedMainTab, selectedPeriodTab);
                    }

                    if (financialsPopup && financialsPopup.expanded) {
                        const tableElement = document.querySelector('#financials-expanded-table');
                        if (tableElement && financialsData) {
                            const tableData = prepareTableData(financialsData, selectedMainTab, selectedPeriodTab);
                            renderTable(tableElement, tableData);
                        }
                    }
                });
            });

            document.addEventListener('click', (e) => {
                if (!statementDropdown.contains(e.target)) {
                    statementDropdown.classList.remove('active');
                }
            });
        }

        const periodButtons = financialsTab.querySelectorAll('.period-btn');
        periodButtons.forEach((button, index) => {
            button.addEventListener('click', () => {
                periodButtons.forEach(btn => btn.classList.remove('active'));
                button.classList.add('active');
                selectedPeriodTab = index;

                if (financialsData) {
                    renderPreviewTable(financialsData, selectedMainTab, selectedPeriodTab);
                }

                if (financialsPopup && financialsPopup.expanded) {
                    const tableElement = document.querySelector('#financials-expanded-table');
                    if (tableElement && financialsData) {
                        const tableData = prepareTableData(financialsData, selectedMainTab, selectedPeriodTab);
                        renderTable(tableElement, tableData);
                    }
                }
            });
        });

        updateStatementLabel();
    }

    function setupEventListeners() {
        /* 
        const previewWrapper = financialsTab.querySelector('.financials-preview-table-wrapper');
        if (previewWrapper) {
            previewWrapper.addEventListener('click', () => {
                if (financialsPopup && financialsPopup.expanded) {
                    closeFinancialsExpanded();
                } else {
                    openFinancialsExpanded();
                }
            });
        } 
        */
        const tableFinance = financialsTab.querySelector('.financials-preview-table-wrapper');
        if (__LOG_INFO__) AppLog.info('tableFinance', financialsTab, tableFinance)
        if (tableFinance) {
            tableFinance.addEventListener('mouseenter', () => {
                if (!financialsPopup || !financialsPopup.expanded) {
                    openFinancialsExpanded();
                }
            })
        }
        const rightWrapper = document.querySelector('.right-wrapper');
        if (rightWrapper) {
             rightWrapper.addEventListener('mouseleave', () => {
                if (financialsPopup && financialsPopup.expanded) {
                    closeFinancialsExpanded();
                }
            })
        }

        updateSelectedTabs();
    }

    function updateFinancialsHeaderVisibility() {
    }

    window.updateFinancialsHeaderVisibility = updateFinancialsHeaderVisibility;

    initAPIManager().then(() => {
        setupEventListeners();
        if (__LOG_INFO__) AppLog.info('✅ Desktop Financials Tab initialized');
        if (isPortraitMobileLayout()) {
            closeFinancialsExpanded();
        }
    });
    async function refreshFinancialsData() {
        const ticker = getCurrentTicker();
        if (!ticker) return;

        if (__LOG_INFO__) AppLog.info(`📊 Financials tab: Refreshing data for ${ticker}`);
        financialsData = null;
        financialsData = await fetchFinancialsData(ticker);
        
        renderPreviewTable(financialsData, selectedMainTab, selectedPeriodTab);

        if (financialsPopup && financialsPopup.expanded) {
            const tableElement = document.querySelector('#financials-expanded-table');
            if (tableElement && financialsData) {
                const tableData = prepareTableData(financialsData, selectedMainTab, selectedPeriodTab);
                renderTable(tableElement, tableData);
                if (__LOG_INFO__) AppLog.info(`📊 Financials tab: Table updated for ${ticker}`);
            }
        }
    }

    const scene = document.querySelector('a-scene');
    if (scene) {
        scene.addEventListener('stock-selected', async (event) => {
            const ticker = event.detail?.ticker || event.detail;
            if (ticker) {
                currentTicker = typeof ticker === 'string' ? ticker : ticker.ticker || ticker;
                if (__LOG_INFO__) AppLog.info(`📊 Financials tab: Ticker updated to ${currentTicker}`);
                checkStockSelection();
                await refreshFinancialsData();
            }
        });
    }

    document.addEventListener('ticker-changed', async (event) => {
        if (event.detail && event.detail.ticker) {
            currentTicker = event.detail.ticker;
            if (__LOG_INFO__) AppLog.info(`📊 Financials tab: Ticker updated to ${currentTicker}`);
            checkStockSelection();
            await refreshFinancialsData();
        }
    });

    document.addEventListener('financials-data-updated', async (event) => {
        if (event.detail && event.detail.financialsData) {
            if (__LOG_INFO__) AppLog.info('📊 Financials tab: Received financials data update event');
            financialsData = event.detail.financialsData;
            if (event.detail.ticker) {
                currentTicker = event.detail.ticker;
            }
            checkStockSelection();
            
            renderPreviewTable(financialsData, selectedMainTab, selectedPeriodTab);

            if (financialsPopup && financialsPopup.expanded) {
                const tableElement = document.querySelector('#financials-expanded-table');
                if (tableElement && financialsData) {
                    const tableData = prepareTableData(financialsData, selectedMainTab, selectedPeriodTab);
                    renderTable(tableElement, tableData);
                    if (__LOG_INFO__) AppLog.info(`📊 Financials tab: Table updated with new data for ${currentTicker}`);
                }
            }
        }
    });

    setInterval(checkStockSelection, 1000);

    document.addEventListener('tab-changed', (e) => {
        if (e.detail && e.detail.tabIndex === 3) {
            setTimeout(checkStockSelection, 100);
            if (isPortraitMobileLayout()) {
                closeFinancialsExpanded();
            }
        }
    });
});

